import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function torus(options) {
  var _ref = options || {},
    buttonPosition = _ref.buttonPosition,
    modalZIndex = _ref.modalZIndex,
    apiKey = _ref.apiKey,
    buildEnv = _ref.buildEnv,
    enableLogging = _ref.enableLogging,
    loginConfig = _ref.loginConfig,
    showTorusButton = _ref.showTorusButton,
    integrity = _ref.integrity,
    whiteLabel = _ref.whiteLabel,
    skipTKey = _ref.skipTKey;
  return function () {
    return {
      label: 'Torus',
      getIcon: function () {
        var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return import('./icon.js');
              case 2:
                return _context.abrupt("return", _context.sent.default);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getIcon() {
          return _getIcon.apply(this, arguments);
        }
        return getIcon;
      }(),
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref2) {
          var chains, _yield$import, Torus, _yield$import2, createEIP1193Provider, ProviderRpcErrorCode, ProviderRpcError, _chains, chain, instance, torusProvider, provider;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                chains = _ref2.chains;
                _context5.next = 3;
                return import('@toruslabs/torus-embed');
              case 3:
                _yield$import = _context5.sent;
                Torus = _yield$import.default;
                _context5.next = 7;
                return import('@web3-onboard/common');
              case 7:
                _yield$import2 = _context5.sent;
                createEIP1193Provider = _yield$import2.createEIP1193Provider;
                ProviderRpcErrorCode = _yield$import2.ProviderRpcErrorCode;
                ProviderRpcError = _yield$import2.ProviderRpcError;
                _chains = _slicedToArray(chains, 1), chain = _chains[0];
                instance = new Torus({
                  buttonPosition: buttonPosition,
                  modalZIndex: modalZIndex,
                  apiKey: apiKey
                });
                _context5.next = 15;
                return instance.init({
                  buildEnv: buildEnv,
                  enableLogging: enableLogging,
                  network: {
                    host: chain.rpcUrl || '',
                    chainId: parseInt(chain.id),
                    networkName: chain.label
                  },
                  showTorusButton: showTorusButton,
                  loginConfig: loginConfig,
                  integrity: integrity,
                  whiteLabel: whiteLabel,
                  skipTKey: skipTKey
                });
              case 15:
                torusProvider = instance.provider;
                provider = createEIP1193Provider(torusProvider, {
                  eth_requestAccounts: function () {
                    var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      var accounts;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return instance.login();
                          case 3:
                            accounts = _context2.sent;
                            return _context2.abrupt("return", accounts);
                          case 7:
                            _context2.prev = 7;
                            _context2.t0 = _context2["catch"](0);
                            throw new ProviderRpcError({
                              code: ProviderRpcErrorCode.ACCOUNT_ACCESS_REJECTED,
                              message: 'Account access rejected'
                            });
                          case 10:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2, null, [[0, 7]]);
                    }));
                    function eth_requestAccounts() {
                      return _eth_requestAccounts.apply(this, arguments);
                    }
                    return eth_requestAccounts;
                  }(),
                  eth_selectAccounts: null,
                  wallet_switchEthereumChain: function () {
                    var _wallet_switchEthereumChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
                      var params, chain;
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            params = _ref3.params;
                            chain = chains.find(function (_ref4) {
                              var id = _ref4.id;
                              return id === params[0].chainId;
                            });
                            if (chain) {
                              _context3.next = 4;
                              break;
                            }
                            throw new Error('chain must be set before switching');
                          case 4:
                            _context3.next = 6;
                            return instance.setProvider({
                              host: chain.rpcUrl || '',
                              chainId: parseInt(chain.id),
                              networkName: chain.label
                            });
                          case 6:
                            return _context3.abrupt("return", null);
                          case 7:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3);
                    }));
                    function wallet_switchEthereumChain(_x2) {
                      return _wallet_switchEthereumChain.apply(this, arguments);
                    }
                    return wallet_switchEthereumChain;
                  }(),
                  eth_chainId: function () {
                    var _eth_chainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref5) {
                      var baseRequest, chainId;
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            baseRequest = _ref5.baseRequest;
                            _context4.next = 3;
                            return baseRequest({
                              method: 'eth_chainId'
                            });
                          case 3:
                            chainId = _context4.sent;
                            return _context4.abrupt("return", "0x".concat(parseInt(chainId).toString(16)));
                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4);
                    }));
                    function eth_chainId(_x3) {
                      return _eth_chainId.apply(this, arguments);
                    }
                    return eth_chainId;
                  }()
                });
                provider.disconnect = function () {
                  return instance.cleanUp();
                };
                return _context5.abrupt("return", {
                  provider: provider,
                  instance: instance
                });
              case 19:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }
        return getInterface;
      }()
    };
  };
}
export default torus;